module.exports = __webpack_public_path__ + "img/title.1e3a1099.png";